export const displayShortDateNoYearFormat = 'dd MMM';
export const displayShortDateFormat = 'dd-MM-yyyy';
export const displayDateTimeFormat = 'dd-MM-yyyy HH:mm';
export const displayTimeFormat = 'HH:mm';
export const inputShortDateFormat = 'dd-MM-yyyy';